






















































import { ActivityIcon } from '@/components';
import { OpportunityTags } from '@/components/opportunities';
import { GeekHistoryOpportunity } from '@/models/geek-profile';
import { uuidv4 } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'HistoryTableOpportunity',
  components: {
    OpportunityTags,
  },
  props: {
    data: Object as () => GeekHistoryOpportunity,
  },
  computed: {
    opportunitySubject(): string {
      return this.$t(
        `geek-profile.history-tab.actions.opportunity.subject`,
        {
          opportunity: this.data.opportunity.subject,
        },
      ) as string;
    },
  },
  methods: {
    goToOpportunityDetails(id: string) {
      this.$router.push({ name: 'opportunity-details', params: { id } });
    },
    uuidv4,
  },
});
